export function trimTrailingChars(s: string, charToTrim: string) {
  var regExp = new RegExp(charToTrim + "+$");
  var result = s.replace(regExp, "");

  return result;
}
